import { log } from '../lib/Logger';

// const WOOCOMMERCE_CONSUMER_KEY = 'ck_1e0087301c4cab602b742ab0b1f97bb0ce89999f';
// const WOOCOMMERCE_CONSUMER_SECRET = 'cs_31acc0c710f3ba573da34c46446628d4dd70578c';

const COCART = false;

export type Product = {
  id: number;
  name: string;
  slug: string;
  status: 'publish';
  catalog_visibility: 'visible';
  description: string; // HTML
  price: string;
  stock_quantity: number;
  stock_status: 'instock';
  images: Array<{
    id: number;
    src: string;
    name: string;
    alt: string;
  }>;
};

type AddToCartRequest = {
  product_id: number;
  return_cart: boolean;
};

export class ShopApi {
  private cartSize = 0;

  constructor(private readonly endpoint: string) {}

  // async getProducts(): Promise<Product[]> {
  //   return [{
  //     id: 10,
  //     name: 'Sculpture',
  //     slug: 'sculpture-test',
  //     status: 'publish',
  //     catalog_visibility: 'visible',
  //     description: '...',
  //     price: '€1500.00',
  //     stock_quantity: 1,
  //     stock_status: 'instock',
  //     images: []
  //   }, {
  //     id: 21,
  //     name: 'Sgombero',
  //     slug: 'sgombero-test',
  //     status: 'publish',
  //     catalog_visibility: 'visible',
  //     description: '...',
  //     price: '€100.00',
  //     stock_quantity: 40,
  //     stock_status: 'instock',
  //     images: []
  //   }];

  //   const url = `${this.endpoint}/wc/v3/products`;
  //   const response = await fetch(url, {
  //     method: 'GET',
  //     headers: new Headers({
  //       'Authorization':
  //           'Basic ' + btoa(WOOCOMMERCE_CONSUMER_KEY + ':' + WOOCOMMERCE_CONSUMER_SECRET),
  //     }),
  //   });
  //   try {
  //     const json = await response.clone().json();
  //     if (!!json.code) {
  //       throw new Error(`${json.code}: ${json.message}`);
  //     }
  //     return json as Product[];
  //   } catch (e) {
  //     log('error', `Error fetching products: ${await response.text()}`);
  //     return [];
  //   }
  // }

  async getCartSize(): Promise<number> {
    if (COCART) {
      const url = `${this.endpoint}/cocart/v1/count-items`;
      const response = await fetch(url, {
        method: 'GET',
      });
      try {
        const json = await response.clone().json();
        if (!!json.code) {
          throw new Error(`${json.code}: ${json.message}`);
        }
        return parseInt(json as string);
      } catch (e) {
        log('error', `Error reading cart size: ${await response.text()}`);
        return 0;
      }
    } else {
      return this.cartSize;
    }
  }

  async addToCart(productId: number): Promise<number> {
    if (COCART) {
      const url = `${this.endpoint}/cocart/v1/add-item`;
      const request: AddToCartRequest = {
        product_id: productId,
        return_cart: true,
      };
      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(request),
      });
      try {
        const json = await response.clone().json();
        if (!!json.code) {
          throw new Error(`${json.code}: ${json.message}`);
        }
        return json as number;
      } catch (e) {
        log('error', `Error adding to cart: ${await response.text()}`);
        return 0;
      }
    } else {
      const url = `/wp-shop/?add-to-cart=${productId}`;
      await fetch(url, { method: 'GET' });
      this.cartSize++;
      return this.getCartSize();
    }
  }
}
